import { Controller } from '@hotwired/stimulus'
import { suggestEmail } from '../lib/email_suggestion'

export default class extends Controller {
  static targets = ['input', 'hint', 'message']
  static values = { message: String }

  connect() {
    this.clear()
  }

  clear() {
    this.hintTarget.hidden = true
    this.messageTarget.textContent = ''
    if (this.dismissedValue !== this.inputTarget.value) this.dismissedValue = null
  }

  check() {
    this.clear()
    if (this.inputTarget.disabled || this.inputTarget.readOnly || this.dismissedValue === this.inputTarget.value) return
    const suggestion = suggestEmail(this.inputTarget.value)
    if (!suggestion) return
    this.messageTarget.textContent = this.messageValue.replace('%{email}', () => suggestion)
    this.hintTarget.hidden = false
  }

  accept() {
    if (this.inputTarget.disabled || this.inputTarget.readOnly) return this.clear()
    const suggestion = suggestEmail(this.inputTarget.value)
    if (!suggestion) return this.clear()
    this.inputTarget.value = suggestion
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
    this.clear()
    this.inputTarget.focus()
  }

  dismiss() {
    this.dismissedValue = this.inputTarget.value
    this.clear()
    this.inputTarget.focus()
  }
}
